<template>
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M10.9382 12.134L12.1284 10.9437L17.4965 16.3118L16.3062 17.502L10.9382 12.134Z" :fill="color" :fill-opacity="opacity"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M4.98331 4.95833C6.63331 3.31667 8.78331 2.5 10.9333 2.5C13.0916 2.5 15.25 3.325 16.8916 4.96667L4.97498 16.8917C1.68331 13.6 1.68331 8.25833 4.97498 4.96667L4.98331 4.95833ZM4.16663 10.9333C4.16663 12.175 4.49997 13.3583 5.11663 14.3917L6.27497 13.2417C5.29163 11.8667 4.7083 10.3 4.54997 8.70833C4.29997 9.41666 4.16663 10.1583 4.16663 10.9333ZM7.48331 12.025C6.35831 10.3167 5.93331 8.275 6.33331 6.33333C6.81664 6.23333 7.29997 6.18333 7.79164 6.18333C9.29164 6.18333 10.75 6.64166 12.025 7.48333L7.48331 12.025ZM10.9333 4.16667C10.1583 4.16667 9.41664 4.3 8.70831 4.55C10.3 4.70833 11.8583 5.29167 13.2333 6.275L14.3916 5.11667C13.3583 4.5 12.175 4.16667 10.9333 4.16667Z" :fill="color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>